module.exports = __webpack_public_path__ + "img/logo-ntte.4f637d4a.svg";